import {
    AnalyticsEvent,
    EVENT_UAEVENT,
    GTMEventData,
} from "@hermes/utils/analytics";

interface EventData {
    eventType: string;
}

/**
 * Class for VTO Error modal
 */
export class VtoErrorAnalyticsEvent implements AnalyticsEvent<GTMEventData> {
    public name: string = EVENT_UAEVENT;

    public eventData: EventData;

    constructor(data: EventData) {
        this.eventData = data;
    }

    public formatForGTM(): GTMEventData {
        const eventlabel = (_eventType: string) =>
            ({
                ERROR_RESOLUTION: "errorMessage::resolution",
                ERROR_CAMERA: "errorMessage::camera",
                ERROR_TIMEOUT: "errorMessage::timeout",
            })[this.eventData.eventType];
        return {
            event: this.name,
            eventcategory: "SingleProductPage",
            eventaction: "TryThisShade",
            eventlabel: eventlabel(this.eventData.eventType),
        };
    }
}
